import styled from "styled-components";
import { Theme } from "../../Theme";

const AbsolutePositionDropdownWrapper = styled.div`
    position: absolute;
    top: ${({ $top }) => $top ?? "100%"};
    left: ${({ $openedLeftSide, $left }) => ($openedLeftSide ? $left : "0")};
    z-index: 1000;
    margin-top: 8px;
    width: ${({ $width }) => ($width ? $width : "auto")};
    min-width: ${({ $minWidth }) => ($minWidth ? $minWidth : "auto")};
    background-color: ${({ $backgroundColor }) => $backgroundColor};
    border-radius: ${({ $borderRadius }) => $borderRadius};
    backdrop-filter: ${({ $backgroundColor }) => ($backgroundColor === Theme.color.white ? "none" : "blur(30px)")};
    -webkit-backdrop-filter: ${({ $backgroundColor }) =>
        $backgroundColor === Theme.color.white ? "none" : "blur(30px)"};
    box-shadow: 0 3px 16px ${Theme.color.black_01};
    padding: ${({ $padding }) => ($padding ? $padding : "0")};
    box-sizing: border-box;
`;

export const CustomAbsolutePositionDropdownWrapper = ({
    openedLeftSide = false,
    width,
    top,
    left = "-130px",
    padding,
    backgroundColor = Theme.color.white_07,
    minWidth,
    borderRadius = "12px",
    children,
}) => {
    return (
        <AbsolutePositionDropdownWrapper
            $openedLeftSide={openedLeftSide}
            $width={width}
            $top={top}
            $left={left}
            $padding={padding}
            $backgroundColor={backgroundColor}
            $minWidth={minWidth}
            $borderRadius={borderRadius}
        >
            {children}
        </AbsolutePositionDropdownWrapper>
    );
};

export const FixedPositionDropdownWrapper = styled.div`
    position: fixed;
    top: ${({ $top }) => $top}px;
    left: ${({ $left }) => $left}px;
    z-index: 1000;
    width: ${({ $width }) => $width}px;
    background-color: ${Theme.color.white};
    border-radius: 8px;
    box-shadow: 0 3px 16px ${Theme.color.black_01};
    padding: 10px 0;
    box-sizing: border-box;
`;

export const ScrollDropdownWrapper = styled.div`
    position: fixed;
    top: ${({ $top }) => $top}px;
    left: ${({ $left }) => $left}px;
    width: ${({ $width }) => $width}px;
    z-index: 1001;
    margin-top: 8px;
    background-color: ${({ $noBlur }) => ($noBlur ? Theme.color.white : Theme.color.white_07)};
    border-radius: 8px;
    backdrop-filter: ${({ $noBlur }) => ($noBlur ? undefined : "blur(30px)")};
    -webkit-backdrop-filter: ${({ $noBlur }) => ($noBlur ? undefined : "blur(30px)")};
    box-shadow: 0 3px 16px ${Theme.color.black_01};
    box-sizing: border-box;
    max-height: 240px;
    overflow-y: auto;
    padding: 10px 0;

    &::-webkit-scrollbar {
        width: 8px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${Theme.color.neutral400};
        border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
    }
`;
